<template>
  <div id="thank">
    <div id="sectionT1">
      <b-container fluid>
        <b-container>
          <div class="HeadContainer">
            <div class="HeadVertical-center">
              <h2>
                <div
                  v-for="(item, index) in title"
                  :key="index"
                >
                  {{ item }}
                </div>
              </h2>
              <h3>
                {{ $t("subtitle") }}
              </h3>
            </div>
          </div>
        </b-container>
      </b-container>
    </div>
    <div id="sectionT2">
      <b-container fluid>
        <b-container class="mb-4 mt-4">
          <b-row>
            <b-col
              md="6"
              sm="12"
            >
              <h3 class="mb-3">
                <strong>
                  {{ $t("title2") }}
                </strong>
              </h3>
              <p
                v-for="(item, index) in texts"
                :key="index"
              >
                {{ item }}
              </p>
            </b-col>
            <b-col
              md="6"
              sm="12"
            >
              <div class="cardd p-3">
                <h3 class="mb-3 text-center">
                  <strong>
                    {{ $t("title3") }}
                  </strong>
                </h3>
                <p>
                  <font-awesome-icon :icon="['fas','map-marked-alt']" />
                  <span class="ml-2">
                    {{ $t("address") }}
                  </span>
                </p>
                <p>
                  <font-awesome-icon :icon="['fas','mobile-alt']" />
                  <span class="ml-2">
                    {{ $t("mobile1") }}
                  </span>
                </p>
                <p>
                  <font-awesome-icon :icon="['fas','mobile-alt']" />
                  <span class="ml-2">
                    {{ $t("mobile2") }}
                  </span>
                </p>
                <p>
                  <font-awesome-icon :icon="['fas','envelope-open-text']" />
                  <span class="ml-2">
                    {{ $t("email1") }}
                  </span>
                </p>
              </div>
            </b-col>
          </b-row>
          <br>
          <b-button
            class="buttonAzul-outline"
            @click="volver()"
          >
            {{ $t("btn") }}
          </b-button>
          <br>
        </b-container>
      </b-container>
    </div>
    <div id="sectionT3">
      <b-container fluid>
        <b-container class="mb-5 mt-5 text-center">
          <br>
          <h2>
            {{ $t("title4") }}
          </h2>
          <br>
          <h3>
            <span
              v-for="(item, index) in texts1"
              :key="index"
            >
              <span v-if="item.type=='txt'">
                {{ item.value }}
              </span>
              <b-link
                v-if="item.type=='link'"
                :href="item.link"
              >
                {{ item.value }}
              </b-link>
            </span>
          </h3>
          <br>
        </b-container>
      </b-container>
    </div>
  </div>
</template>

<i18n>
{
  "en":{
    "title": [
      "\"WE ARE A BUSINESS SCHOOL"
      , "THAT GIVES YOU WEAPONS TO GROW\""
    ]
    , "subtitle": "Thank you for filling out the form!"
    , "title2": "We have received your message!"
    , "texts": [
      "Thank you for completing the form, we have correctly received your message and, as soon as possible, we will contact you. Please be patient, your request is in the process of being answered!"
      , "Do not forget to check all the folders in your mail and spam. Thank you!"
    ]
    , "title3": "FIND US"
    , "address": "CALLE LEÓN Y CASTILLO NO 54, 1A PLANTA LAS PALMAS DE GRAN CANARIA"
    , "mobile1": "+34 928 35 46 68"
    , "mobile2": "+34 617 78 34 60"
    , "email1": "rh@aicad.es"
    , "btn": "Go Back"
    , "title4": "Are you looking for job opportunities?"
    , "texts1": [
      {
        "type": "txt"
        , "value": "You registered for free at "
      },
      {
        "type": "link"
        , "value": "jobs.aicad.es"
        , "link": "https://jobs.aicad.es"
      }
    ]
  },
  "es":{
    "title": [
      "\"SOMOS UNA ESCUELA DE NEGOCIOS"
      , "QUE TE DA ARMAS PARA CRECER\""
    ]
    , "subtitle": "¡Gracias por rellenar el formulario!"
    , "title2": "¡Hemos recibido su mensaje!"
    , "texts": [
      "Gracias por completar el formulario, hemos recibido correctamente tu mensaje y, con la mayor brevedad, nos pondremos en contacto contigo. Por favor, ten paciencia, ¡tu solicitud está en vía de responderse!"
      , "No te olvides de comprobar todas las carpetas de tu correo y el spam. ¡Gracias!"
    ]
    , "title3": "ENCUÉNTRANOS"
    , "address": "CALLE LEÓN Y CASTILLO NO 54, 1A PLANTA LAS PALMAS DE GRAN CANARIA"
    , "mobile1": "+34 928 35 46 68"
    , "mobile2": "+34 617 78 34 60"
    , "email1": "rh@aicad.es"
    , "btn": "Volver"
    , "title4": "¿Buscas oportunidades laborales?"
    , "texts1": [
      {
        "type": "txt"
        , "value": "Registraste gratis en "
      },
      {
        "type": "link"
        , "value": "jobs.aicad.es"
        , "link": "https://jobs.aicad.es"
      }
    ]
  }
}
</i18n>

<script>
export default {
    computed: {
        title(){
            return this.$t("title");
        },
        texts(){
            return this.$t("texts");
        },
        texts1(){
            return this.$t("texts1");
        }
    },
    methods: {
        volver() {
            if(localStorage.storedData != 'thank'){
                this.$router.push({ name: localStorage.storedData });
            }else{
                this.$router.push({ path: '/' });
            }
        }
    },
}
</script>

<style lang="scss">
#thank{
  #sectionT1{
    background: linear-gradient(236deg,rgba(181,255,255,.546656),rgba(0,47,47,.653099))
    , url("~@/assets/images/aicad-team.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: whitesmoke;
  }

  #sectionT2{
    .cardd{
      -webkit-box-shadow: -1px 4px 5px 0px rgba(0, 0, 0, 0.75);
      -moz-box-shadow: -1px 4px 5px 0px rgba(0, 0, 0, 0.75);
      box-shadow: -1px 4px 5px 0px rgba(0, 0, 0, 0.75);
      transition: 0.3s;
      border-top: 0.4em solid #0070a8 !important;
      border-radius: 0.75em !important;
      font-weight: 700;
      background-color: transparent;
    }
    
    .buttonAzul-outline{
      border-radius: 30px !important;
      border-color: #2c3e50 !important;
      border-width: 2px !important;
      background-color: transparent !important;
      color: #2c3e50 !important;
      margin: 0 auto;
      letter-spacing: 2px;
      padding: 0.4em 3em !important;
      cursor: pointer;
      font-size: 1.1em !important;
      transition: 0.3s !important;
    }

    .buttonAzul-outline:hover{
      opacity: .85;
      text-decoration: inherit !important;
      transform: scale(1.1);
    }
  }

  #sectionT3{
    background: linear-gradient( rgb(0, 112, 168), rgb(0, 124, 124));
    color: whitesmoke;
    a{
      color: whitesmoke !important;
      text-decoration: underline !important;
    }
  }
}
</style>